import React from 'react';
import { ClickToChat } from '@americanexpress/shared-scripts';

const SupportChatScript = () => (
  <ClickToChat
    version="^1.0.0"
    market="US"
    locale="en-US"
    lineOfBusiness="businesses_checking"
  />
);

export default SupportChatScript;
